<template>
    <div class="load-container my-6 text-center">
        <button v-if="loadMoreStatus" class="btn btn-outline-primary" @click="loadMore($event)" :disabled="loadMoreStatus !== true">
            <slot v-if="loadMoreStatus === true"></slot>
            <span v-else>Loading</span>
        </button>
    </div>
</template>

<script>
    export default {
        props: ["showLoadMore"],

        computed: {
            loadMoreStatus() {
                return this.showLoadMore
            },
        },

        methods: {
            loadMore(e) {
                this.$emit('loadmore', e)
            }
        },
    }
</script>

<style scoped>
    .load-container {
        min-height: 1.9rem;
    }
</style>